import styles from "./check.module.scss";
import { BlockText } from "../text/BlockText";
import { Desc } from "../../typo/Desc";

interface IItem {
  name: string;
  id: string;
}

export const Check = ({
  list,
  checked,
  onClick,
}: {
  list: IItem[];
  checked: IItem;
  onClick: (item?: IItem) => void;
}) => {
  return (
    <>
      <ul className={styles["check-list"]}>
        {list?.map((item: IItem, index: number) => {
          return (
            <li key={`${item?.id}-${item?.name}-${index}`}>
              <BlockText
                style={{
                  padding: "14px 0",
                }}
                backgroundColor="transparent"
                desc={
                  <Desc
                    text={item.name}
                    fontSize="15px"
                    color={checked?.id?.toString() === item?.id?.toString() ? "#9D7D54" : "#191919"}
                    fontWeight={checked?.id?.toString() === item?.id?.toString() ? "700" : "400"}
                  />
                }
                onClick={() => {
                  onClick && onClick(item);
                }}
                showIcon={checked?.id?.toString() === item?.id?.toString()}
                iconType="check"
              />
            </li>
          );
        })}
      </ul>
    </>
  );
};
